import { useEffect, useRef } from "react";
import classNames from "classnames/dedupe";
import { getOptionValue, getOptionLabel } from "./utils";
import type { ComboboxOption, ComboboxOptionProps } from "./types";

export const Option = <T extends ComboboxOption>({
  option,
  isHighlighted,
  onOptionSelect,
  optionComponent: OptionComponent,
  id,
}: ComboboxOptionProps<T>) => {
  const optionRef = useRef<HTMLLIElement>(null);

  useEffect(() => {
    if (
      isHighlighted &&
      optionRef.current &&
      optionRef.current.scrollIntoView
    ) {
      optionRef.current.scrollIntoView({ block: "nearest" });
    }
  }, [isHighlighted]);

  return (
    <li
      ref={optionRef}
      role="option"
      key={getOptionValue(option)}
      id={id}
      aria-selected={isHighlighted}
      onMouseDown={() => onOptionSelect(option)}
      className={classNames("mobius-combobox__option", "has-pii", {
        "mobius-combobox__option--is-highlighted": isHighlighted,
      })}
    >
      {OptionComponent ? (
        <OptionComponent option={option} isHighlighted={isHighlighted} />
      ) : (
        getOptionLabel(option)
      )}
    </li>
  );
};
